import { render } from "./RelatedProduct.vue?vue&type=template&id=8390b360"
import script from "./RelatedProduct.vue?vue&type=script&lang=js"
export * from "./RelatedProduct.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__